import { Divider, Grid } from "@mui/material"
import { ISettingsItem } from "../Settings"

export default function DividerComponent({ name }: ISettingsItem) {
  return (
    <Grid item className={name ? `${name} divider` : "divider"}>
      <Divider />
    </Grid>
  )
}